export default __webpack_public_path__ + "static/media/mt5.1ca35e17.png";